import { SvgIcon, SxProps } from "@mui/material";
import SquareQuestionSvg from "jsx:../../../Images/Icons/FontAwesome/solid/square-question.svg";

export function SquareQuestionSolidIcon(props: SxProps) {
    return <SvgIcon component={SquareQuestionSvg} inheritViewBox sx={props} />;
}
